import { RenderContentBlock } from '@tunasong/editor'
import { Edit, PollFinalOption, Poll as PollIcon, PollResults } from '@tunasong/icons'
import { LayoutFilters } from '@tunasong/plugin-lib'
import type { TunaPlugin } from '@tunasong/plugin-lib'
import type { Poll } from '@tunasong/schemas'
import ActionItems from './actions/index.js'
import DefaultContentView from './content/default.js'
import ResponsesView from './content/responses.js'
import InsertBlock from './insert-block.js'
import { Properties } from './properties.js'
import { pollTemplates } from './templates.js'
import DefaultView from './views/default.js'
import EditView from './views/edit.js'
import FinalOptionView from './views/final-option.js'
import ResponseView from './views/responses.js'

const plugin = (): TunaPlugin<Poll> => ({
  key: 'poll',
  node: {
    type: 'poll',
    isVoid: true,
    isElement: true,
    component: RenderContentBlock,
  },
  color: 'indigo',
  description: 'Poll',
  category: 'social',
  icon: PollIcon,
  showPropertiesOnInsert: true,
  insertBlock: InsertBlock,
  templates: pollTemplates,
  components: {
    Content: {
      poll: DefaultContentView,
      responses: ResponsesView,
    },
    Properties,
    Actions: ActionItems,
  },
  layouts: [
    { name: 'Default', Icon: PollIcon, Component: DefaultView },
    {
      name: 'Edit',
      Icon: Edit,
      Component: EditView,
      show: LayoutFilters.owner,
    },
    { name: 'Responses', Icon: PollResults, Component: ResponseView },
    { name: 'Final Option', Icon: PollFinalOption, Component: FinalOptionView },
  ],
  plugins: [
    {
      key: 'pollresponse',
      node: {
        type: 'pollresponse',
      },
      color: 'indigo',
      icon: PollIcon,
    },
  ],
})

export default plugin
